import apiClient from '@/Services/Clients/apiClient';
import { UserSummaryDto } from '@/Types/userSummaryDto';
import { PersonaSummaryDto } from '@/Types/personaSummaryDto';
import UserDetailsServerModel from '@/VueComponents/PageComponents/Users/Models/userDetailsServerModel';
import UpdateUserDetailsModel from '@/VueComponents/PageComponents/Users/Models/updateUserDetailsModel';
import CreateUserDetailsModel from '@/VueComponents/PageComponents/Users/Models/createUserDetailsModel';

const USERS_BASE_URL = 'api/users';
class UsersService {
  /**
   * @param {string} businessId
   * @return {Promise}
   */
  public static getAllUsers(businessId: string): Promise<UserSummaryDto[]> {
    return apiClient.get(`${USERS_BASE_URL}/${businessId}`);
  }

  /**
  * @param {string} businessId
  * @return {Promise}
  */
  public static getAllPersonaSummaries(businessId: string): Promise<PersonaSummaryDto[]> {
    return apiClient.get(`${USERS_BASE_URL}/${businessId}/personasummary`);
  }

  /**
   * @param {string} businessId
   * @param {string} personaId
   * @return {Promise}
   */
  public static getUserDetails(businessId: string, personaId: string): Promise<UserDetailsServerModel> {
    return apiClient.get(`${USERS_BASE_URL}/${businessId}/${personaId}`);
  }

  /**
  * @param {string} businessId
  * @param {string} personaId
  * @param {object} userDetails
  * @return {Promise}
  */
  public static updateBusinessUserDetails(businessId: string, personaId: string, userDetails: UpdateUserDetailsModel)
    : Promise<UserDetailsServerModel> {
    return apiClient.put(`${USERS_BASE_URL}/${businessId}/${personaId}`, userDetails);
  }

  /**
  * @param {string} businessId
  * @param {object} userDetails
  * @return {Promise}
  */
  public static createBusinessUser(businessId: string, userDetails: CreateUserDetailsModel):Promise<void> {
    return apiClient.post(`${USERS_BASE_URL}/${businessId}`, userDetails);
  }

  /**
   * @param {string} businessId
   * @param {string} personaId
   * @return {Promise}
   */
  public static deleteBusinessUser(businessId: string, personaId: string): Promise<void> {
    return apiClient.delete(`${USERS_BASE_URL}/${businessId}/${personaId}`);
  }
}

export default UsersService;
